<template>
  <div class="shareApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="card">
      <ul>
        <li v-for="(item,i) in setDetail">
          <img class="left" :src="item.avatar">
          <div class="right">
            <h3>{{item.name}}</h3>
            <div class="price">有效期:<font>{{item.starttime}} 至 {{item.endtime}}</font></div>
            <div class="price">股份：
              <font class="rates" style="padding-right:15px">{{item.num}}股</font>
              支付金额：
              <font class="rates">{{item.price}}元</font>
            </div>
          </div>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: true,
        baseUrl:'',
        setDetail:[],
        positionFlag:false
      };
    },
    created(){
      this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getDetail()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/crowd/buy',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data;
          that.setDetail = res.data;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .shareApp{
    background:#f5f5f5;
  }


  .shareApp .card{
    width:100%;
    display:block;
    min-height:400px;
    padding-bottom:10px;
    padding-top:10px
  }
  .shareApp .card ul{
    width:92%;
    display:block;
    margin:0 auto;
  }
  .shareApp .card ul li{
    width:100%;
    margin:0px auto 15px auto;
    padding:15px 0;
    background:#fff;
    border-radius:5px;
  }
  .shareApp .card ul li:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .shareApp .card ul li:last-child{
    border-bottom:none
  }
  .shareApp .card ul li .left{
    float:left;
    width:60px;
    border-radius: 6px;
    margin-left:4%
  }
  .shareApp .card ul li .right{
    float:left;
    width:75%;
    margin-left:3%
  }
  .shareApp .card ul li .right h3{
    font-size:15px
  }
  .shareApp .card ul li .right .price{
    color:#666;
    font-size:12px;
    padding-top:5px
  }
  .shareApp .card ul li .right .price font{
    color:#000;
  }
  .shareApp .card ul li .right .price font.rates{
    color:red;
    font-weight:bold;
    font-size:14px
  }
  .shareApp .card ul li .right .price font i{
    font-size:12px;
    font-style:normal;
  }
  .shareApp .card ul li .right .price span{
    text-decoration: line-through;
    padding-left:10px
  }
  
</style>